import React, { Component, Fragment } from 'react'
import { motion } from 'framer-motion'
import { Dialog, Transition } from '@headlessui/react'
import IosInstallSteps from '../UI/IosInstallSteps'
import tools from '../../tools'

//iPhone/iPad hors PWA : pas de PushManager tant que l'app n'est pas installée
//sur l'écran d'accueil ; l'invitation reste pertinente car l'installation débloque
export function needsIosInstall()
{
	if (typeof window === 'undefined' || 'PushManager' in window)
		return false
	if (tools.isStandalone() === true)
		return false
	return tools.isIos(navigator.userAgent, navigator.platform, navigator.maxTouchPoints)
}

export function canShowOptIn(user)
{
	if (typeof window === 'undefined' || !('serviceWorker' in navigator))
		return false
	if (user && user.promote_notification)
		return false
	if ('PushManager' in window && 'Notification' in window)
		return Notification.permission === 'default'
	return needsIosInstall()
}

const demo_icons = [
	'M8 7V3m8 4V3M5 11h14M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
	'M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999A5.002 5.002 0 103 15z',
	'M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
]
const demo_times = ['10:24', '13:05', '18:37']
const demo_transforms = ['rotate(-2deg) translateX(-8px)', 'rotate(1.5deg) translateX(14px)', 'rotate(-1deg) translateX(-2px)']

class NotificationOptIn extends Component {
	constructor(props) {
		super(props)
		this.state = {
			show_ios_sheet: false
		}
	}

	handleAccept = () => {
		if (needsIosInstall() === true)
		{
			this.setState({ show_ios_sheet: true })
			return ;
		}
		const result = this.props.handleAcceptNotifications(true)
		if (result && result.catch)
			result.catch(err => console.log('notification opt-in refused', err))
	}

	closeIosSheet = () => {
		this.setState({ show_ios_sheet: false })
	}

	handleLater = () => {
		this.props.handleAcceptNotifications(false)
	}

	renderScreen(themeColor, optin) {
		return (
			<div className="pt-2 px-1">
				<div className="space-y-4 mb-8">
					{optin.demo.map((item, index) => (
						<div
							key={index}
							className="rounded-2xl flex gap-3 bg-white"
							style={{ padding: '14px 16px', boxShadow: '0 10px 24px -10px rgba(15,23,42,0.22), 0 0 0 1px rgba(15,23,42,0.04)', transform: demo_transforms[index] }}
						>
							<div className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center" style={{ backgroundColor: themeColor + '18' }}>
								<svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} style={{ color: themeColor }}>
									<path strokeLinecap="round" strokeLinejoin="round" d={demo_icons[index]} />
								</svg>
							</div>
							<div className="flex-1 min-w-0">
								<div className="flex items-baseline justify-between gap-2 mb-0.5">
									<h4 className="font-semibold text-sm leading-tight truncate text-slate-900" style={{ margin: 0 }}>{item.title}</h4>
									<span className="text-xs text-slate-400 flex-shrink-0">{demo_times[index]}</span>
								</div>
								<p className="text-sm text-slate-500 leading-snug" style={{ margin: 0 }}>{item.text}</p>
							</div>
						</div>
					))}
				</div>
				<h2 className="text-2xl font-extrabold text-slate-900 leading-tight mb-2" style={{ margin: '0 0 8px' }}>{optin.title}</h2>
				<p className="text-sm text-slate-500 leading-relaxed" style={{ margin: '0 0 32px' }}>{optin.subtitle}</p>
				<motion.div whileTap={{ scale: 0.95 }}>
					<button
						onClick={this.handleAccept}
						className="w-full py-4 rounded-full font-bold text-lg text-white"
						style={{ backgroundColor: themeColor, backgroundImage: 'none', border: 0, boxShadow: `0 10px 22px -10px ${themeColor}` }}
					>
						{optin.accept}
					</button>
				</motion.div>
				<button
					onClick={this.handleLater}
					className="w-full py-3 mt-1 text-center font-semibold text-slate-500"
					style={{ backgroundColor: 'transparent', backgroundImage: 'none', border: 0 }}
				>
					{optin.later}
				</button>
			</div>
		)
	}

	renderCard(themeColor, optin) {
		return (
			<div
				className="relative overflow-hidden mb-5 rounded-3xl"
				style={{ background: `linear-gradient(135deg, ${themeColor}, ${themeColor})`, boxShadow: `0 14px 28px -14px ${themeColor}` }}
			>
				<div className="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-2xl pointer-events-none" />
				<div className="absolute -left-4 -bottom-4 w-32 h-32 bg-black/5 rounded-full blur-2xl pointer-events-none" />
				<button
					onClick={this.handleLater}
					className="absolute z-20 p-2"
					style={{ top: '4px', right: '6px', backgroundColor: 'transparent', backgroundImage: 'none', border: 0, color: 'rgba(255,255,255,0.75)' }}
				>
					<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
				<div className="relative z-10" style={{ padding: '16px 16px 18px' }}>
					<div className="flex items-center gap-3" style={{ marginBottom: '8px' }}>
						<div className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center" style={{ backgroundColor: 'rgba(255,255,255,0.18)' }}>
							<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} className="text-white">
								<path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
							</svg>
						</div>
						<h3 className="text-white font-extrabold text-base" style={{ margin: 0 }}>{optin.title}</h3>
					</div>
					<p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)', margin: '0 0 13px' }}>{optin.card_text}</p>
					<motion.div whileTap={{ scale: 0.95 }} className="inline-block">
						<button
							onClick={this.handleAccept}
							className="rounded-full font-bold text-sm"
							style={{ padding: '10px 26px', backgroundColor: '#ffffff', backgroundImage: 'none', border: 0, color: themeColor, boxShadow: '0 6px 14px -6px rgba(15,23,42,0.35)' }}
						>
							{optin.accept}
						</button>
					</motion.div>
				</div>
			</div>
		)
	}

	renderIosSheet(themeColor, optin) {
		const home = this.props.lang_assets.home
		return (
			<Transition show={this.state.show_ios_sheet} as={Fragment}>
				<Dialog as="div" className="fixed inset-0 z-40" onClose={this.closeIosSheet}>
					<Transition.Child
						as={Fragment}
						enter="transition-opacity ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="transition-opacity ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
					</Transition.Child>
					<Transition.Child
						as={Fragment}
						enter="transform transition ease-out duration-300"
						enterFrom="translate-y-full"
						enterTo="translate-y-0"
						leave="transform transition ease-in duration-200"
						leaveFrom="translate-y-0"
						leaveTo="translate-y-full"
					>
						<div className="fixed inset-x-0 bottom-0 z-50 bg-white rounded-t-3xl px-5 pt-3 pb-8">
							<div className="mx-auto w-10 h-1 rounded-full bg-gray-300 mb-3"></div>
							<Dialog.Title className="text-lg font-bold text-gray-900" style={{ margin: 0 }}>{optin.ios_title}</Dialog.Title>
							<p className="text-sm text-gray-500 leading-relaxed" style={{ margin: '6px 0 4px' }}>{optin.ios_text}</p>
							<IosInstallSteps lang_assets={this.props.lang_assets} />
							<motion.div whileTap={{ scale: 0.95 }} className="mt-6">
								<button
									onClick={this.closeIosSheet}
									className="w-full py-4 rounded-full font-bold text-lg text-white"
									style={{ backgroundColor: themeColor, backgroundImage: 'none', border: 0 }}
								>
									{home.understood}
								</button>
							</motion.div>
						</div>
					</Transition.Child>
				</Dialog>
			</Transition>
		)
	}

	render() {
		if (!canShowOptIn(this.props.user))
			return null
		const optin = this.props.lang_assets.notifications.optin
		if (!optin)
			return null
		const themeColor = '#' + this.props.theme.color1
		const body = (this.props.variant === 'card')
			? this.renderCard(themeColor, optin)
			: this.renderScreen(themeColor, optin)
		return (
			<Fragment>
				{body}
				{this.renderIosSheet(themeColor, optin)}
			</Fragment>
		)
	}
}

export default NotificationOptIn
